// observe-visibility.directive.ts
import {
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { IntersectionObserverService } from '../services/intersection-observer.service';

@Directive({
  selector: '[observeVisibility]'
})
export class ObserveVisibilityDirective implements OnInit, OnDestroy {
  @Output() visibleChange = new EventEmitter<boolean>();
  private subscription?: Subscription;

  constructor(
    private el: ElementRef,
    private ios: IntersectionObserverService
  ) {}

  ngOnInit() {
    // start observing
    this.ios.initializeIntersectionObserver(
      this.el.nativeElement,
      (isVisible: boolean) => this.visibleChange.emit(isVisible)
    );
  }

  ngOnDestroy() {
    // clean up
    this.ios.unobserveElement(this.el.nativeElement);
    this.subscription?.unsubscribe();
  }
}
